<template>
  <v-row>
    <v-col cols="12">
      <BaseBlock title="Conditions de travail des stagiaires">
        <p class="text-sm-left body-2 font-italic">
          Les informations à renseigner ne le sont qu’à titre indicatif et ne
          sauraient préjuger de l’avis qui sera émis par la commission régionale
          d’agrément.
        </p>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="12" md="4">
              <p class="subtitle-1 text-left">
                &#187; Existe-t-il un bureau ou un espace réservé aux stagiaires
                pour effectuer leur travail ?
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.bureauReserve"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="bureauReserve"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="bureauReserve"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <p class="subtitle-1 text-left">
                Les moyens suivants sont-ils disponibles pour les stagiaires :
              </p></v-col
            >
          </v-row>
          <v-row>
            <v-col cols="1" />
            <v-col cols="12" md="4">
              <p class="subtitle-1 text-left">
                &#187; Ordinateur
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.ordinateur"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="ordinateur"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="ordinateur"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="1" />
            <v-col cols="12" md="4">
              <p class="subtitle-1 text-left">
                &#187; Revues professionnelles
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.revueProfessionnelle"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="revueProfessionnelle"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="revueProfessionnelle"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="1" />
            <v-col cols="12" md="4">
              <p class="subtitle-1 text-left">
                &#187; Formation/outils de formation
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.formationOutil"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="formationOutil"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="formationOutil"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="1" />
            <v-col cols="12" md="4">
              <p class="subtitle-1 text-left">
                &#187; Documents professionnels
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.documentProfessionnel"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="documentProfessionnel"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="documentProfessionnel"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="1" />
            <v-col cols="12" md="4">
              <p class="subtitle-1 text-left">
                &#187; Bonnes pratiques de dispensation, de préparation
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.bonnesPratiques"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="bonnesPratiques"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="bonnesPratiques"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="1" />
            <v-col cols="12" md="4">
              <p class="subtitle-1 text-left">
                &#187; Autres (référentiels internes...)
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.autreReferentiel"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="autreReferentiel"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="autreReferentiel"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="8"> </v-col>
          </v-row>
          <v-row>
            <v-col cols="5" />
            <v-col cols="1">
              <v-btn
                color="blue"
                class="mr-4 white--text"
                @click="submit"
                :disabled="!valid"
                >Enregistrer et passer à l'étape suivante
                <v-icon>navigate_next</v-icon></v-btn
              >
            </v-col>
          </v-row>
        </v-form>
      </BaseBlock>
    </v-col>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";
import moment from "moment";

export default {
  name: "Partie14",
  props: ["dossier"],
  components: { BaseBlock },
  data: () => ({
    valid: true,
    menu: false,
    dateFormationEtp: null,
    textRules: [v => !!v || "Ce champ est requis"],
    radioRules: [v => v !== null || "Ce champ est requis"],
    numberRules: [
      v =>
        /^-?([0-9]\d*\.?\d*)$/.test(v) ||
        "La superficie doit être composée uniquement de chiffres"
    ]
  }),
  computed: {
    formatedDate() {
      return this.dateFormationEtp
        ? moment(this.dateFormationEtp).format("DD/MM/YYYY")
        : "";
    }
  },
  created() {
    if (this.dossier.dateFormationEtp) {
      let unix_timestamp = this.dossier.dateFormationEtp;
      var date = new Date(unix_timestamp);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      if (month < 10) month = "0" + month;
      if (day < 10) day = "0" + day;
      this.dateFormationEtp = year + "-" + month + "-" + day;
    }
  },
  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        this.dossier.dateFormationEtp = this.dateFormationEtp;
        this.$emit("save");
        this.$emit("nextPart");
      }
    }
  }
};
</script>
